module.exports = __webpack_public_path__ + "static/media/Chat_agente.508697d4.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Images/WorkBar/Chat_agente.svg
// module id = 1858
// module chunks = 0